module.exports = __webpack_public_path__ + "img/orbit-banner.40f647b0.png";